<script>
// Utilities

/**
 * Transforms a string to camel case
 *
 * @param {String} val - The string to transform
 * @returns {String} - The transformed string
 */
const toCamelCase = (val) => {
    return val.split('-').map((str, i) => {
        return i === 0 ? str : str.charAt(0).toUpperCase() + str.slice(1)
    }).join('');
};

/**
 * Transforms a string to uppercase snake case
 *
 * @param {String} val - The string to transform
 * @returns {String} - The transformed string
 */
const toUpperSnakeCase = (val) => {
    return val.toUpperCase().split('-').join('_');
};

export default {
    data: () => ({
        isLoading: false,
        isErrored: false,
        activeTab: undefined,
        previousTab: undefined,
        animateInLeft: 'contact__tabcontent-item--active animated fadeIn',
        animateInRight: 'contact__tabcontent-item--active animated fadeIn',
        animateOutLeft: '',
        animateOutRight: '',
        hashIndices: ['in-the-know', 'warranty', 'realtors', 'careers'],
        modalOpen: '',
    }),
    computed: {
        previousIndex() {
            return this.hashIndices.indexOf(this.previousTab);
        },
        activeIndex() {
            return this.hashIndices.indexOf(this.activeTab);
        },
        animateInClass() {
            return this.activeIndex > this.previousIndex
                ? this.animateInRight
                : this.animateInLeft
        },
        animateOutClass() {
            return this.activeIndex > this.previousIndex
                ? this.animateOutLeft
                : this.animateOutRight;
        }
    },
    created() {
        // Prevents initial scroll/jump if page is loaded
        // with a hash
        if (window.location.hash) {
            const to = window.setTimeout(() => {
                window.scrollTo(0, 0);
                window.clearTimeout(to);
            }, 500);
        }
    },
    mounted() {
        this.handleHashchange();
        window.addEventListener('hashchange', this.handleHashchange, false);
    },
    beforeDestroy() {
        window.removeEventListener('hashchange', this.handleHashchange);
    },
    methods: {

        /**
         * Updates the data property `this.activeTab` and
         * replaces the hash in the url
         *
         * @param {String} tab - Tab/hash to set as active
         */
        updateTab(tab) {
            this.previousTab = this.activeTab;
            this.activeTab = tab;
            window.history.replaceState({}, '', `${window.location.pathname}#${tab}`);
        },

        /**
         * Gets the current hash of the url, updates the tabs
         * and if no content exists, loads it
         */
        handleHashchange() {
            const activeHash = window.location.hash || '#in-the-know';
            const activeTab = activeHash.slice(1);

            // Prevent default scrolling
            window.scrollTo(0, 0);

            if (!activeTab) {
                // If no tab is active, load the first tab
                this.updateTab('in-the-know');
            } else {
                // Otherwise set the tab to the current hash
                this.previousTab = this.activeTab;
                this.activeTab = activeTab;
            }
        },

        /**
         * Loads the gallery data for the current tab/hash
         *
         * @todo - Store this with a timestamp in localstore so
         *         when a user returns to page within an hour(?) period
         *         the page loads immediately
         *
         * @param {String} tab - Tab (gallery category) to retrieve
         * @returns {Promise} - Returns a promise
         */
        loadGalleryData(tab) {
            this.isLoading = true;

            this.isLoading = false;
        },

        /**
         * Provides the tab content with the proper animation class
         *
         * @param {String} tab - The tab requesting its class
         * @returns {String} - The class
         */
        getAnimateClass(tab) {
            let tabClass = '';

            if (this.activeTab === tab) {
                tabClass = this.animateInClass;
            } else if (this.previousTab === tab) {
                tabClass = this.animateOutClass;
            }
            return tabClass;
        },

        /**
         * Closes the modal
         */
        closeModal() {
            this.modalOpen = '';
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/contact.vue